import NoPolicyDetected from "./NoPolicyDetected";
import NCOorFCPA from "./NCOorFCPA";
import MonthlyContext from "./MonthlyContext";
import DateAffected from "./DateAffected";
import { useSelector } from "react-redux";
import { getDeepViewValuesEntry } from "../../deepViewFieldMap";

// The states that badge as "Fenced CPA Applied" / "NCO Applied"
const OFFSET_APPLIED_STATES = ["fenced_cpa", "negative_offset"];

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

const StageSix = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );

  // Last segment of e.g. "stage6.offset.negative_offset"
  const stage6State =
    String(
      getDeepViewValuesEntry(deepViewData, columnKey)?.stage6_template_key ??
        "",
    )
      .split(".")
      .pop() ?? "";

  // Anything else — including an unknown key — has no offset to break down
  if (!OFFSET_APPLIED_STATES.includes(stage6State)) return <NoPolicyDetected />;

  return (
    <>
      <NCOorFCPA columnKey={columnKey} />
      <MonthlyContext />
      <DateAffected />
    </>
  );
};

export default StageSix;
